var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-8" },
        [_c("breadcrumb", { attrs: { page: _vm.page } })],
        1
      ),
      _c("div", { staticClass: "col-4" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c(
              "action-button",
              {
                staticClass: "m-2",
                attrs: { i: "fas fa-arrow-circle-left", variant: "success" }
              },
              [_vm._v(" Regresar ")]
            )
          ],
          1
        )
      ])
    ]),
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-4" }, [
        _c(
          "div",
          { staticClass: "custom-fiscal-year" },
          [
            _c("p", [_vm._v("Año Fiscal")]),
            _c("custom-drop-down", {
              staticClass: "custom-fiscal-year-select",
              attrs: {
                fieldkey: "id",
                fieldname: "name",
                label: "",
                placeholder: "Seleccione",
                required: ""
              }
            })
          ],
          1
        )
      ]),
      _vm._m(1)
    ]),
    _c("div", { staticClass: "col-12 custom-tab-container" }, [
      _c("div", { staticClass: "no-margin-bottom" }, [
        _c("div", { staticClass: "custom-left-separator" }),
        _c("div", { staticClass: "custom-tab-content" }, [
          _c(
            "ul",
            {
              staticClass: "tab-list nav nav-pills mb-3",
              attrs: { role: "tablist" }
            },
            _vm._l(this.visibleTabs(_vm.tabs), function(item) {
              return _c(
                "li",
                {
                  key: item.Id,
                  class:
                    "nav-item-Sub-menu text-center " + _vm.tabRender(item.Name)
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link no-margin-left",
                      class: { active: _vm.isActive(item.Name) },
                      attrs: {
                        "aria-controls": "tab-i",
                        "aria-selected": "true",
                        href: "#tab-i",
                        role: "tab"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.setActive(item.Id)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.Caption) + " ")]
                  )
                ]
              )
            }),
            0
          )
        ]),
        _c("div", { staticClass: "custom-right-separator" })
      ]),
      _c(
        "div",
        { staticClass: "tab-content" },
        [
          _c(
            "keep-alive",
            [
              _c(
                _vm.activeTab,
                _vm._b(
                  { ref: "currenTab", tag: "component" },
                  "component",
                  _vm.currentProperties,
                  false
                )
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "dropdown-divider mt-0 pb-2 ml-3 w-100 line" })
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-8" }, [
      _c("div", { staticClass: "custom-selected" }, [
        _c("p", [_vm._v("150 Seleccionados")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }